var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1080(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99805 4.49219C3.6173 4.49219 2.49805 5.61135 2.49805 6.99219V8.65885V16.1589C2.49805 17.9997 3.99046 19.4922 5.83138 19.4922H14.1647C16.0056 19.4922 17.498 17.9997 17.498 16.1589V8.65885C17.498 8.19885 17.125 7.82552 16.6647 7.82552C16.6647 7.82552 14.2457 7.82552 12.498 7.82552C11.8691 7.82552 11.6668 7.62135 11.1699 6.62718C10.4168 5.12135 9.7858 4.49219 8.33138 4.49219H4.99805ZM4.99805 6.15885H8.33138C8.9603 6.15885 9.16263 6.36302 9.65954 7.35719C9.76829 7.57469 9.81338 7.64385 9.91988 7.82552C7.0483 7.82552 4.98555 7.82552 4.16471 7.82552V6.99219C4.16471 6.53219 4.5378 6.15885 4.99805 6.15885ZM8.33138 12.8255H11.6647C12.125 12.8255 12.498 13.1989 12.498 13.6589C12.498 14.1189 12.125 14.4922 11.6647 14.4922H8.33138C7.87113 14.4922 7.49805 14.1189 7.49805 13.6589C7.49805 13.1989 7.87113 12.8255 8.33138 12.8255Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1080);
export default __webpack_public_path__ + "static/media/1080.4753af330135a5cbdaf09caeaf4268d7.svg";
export { ForwardRef as ReactComponent };